import { useState } from "react";
import { useTranslator } from "../providers/TranslatorProvider";
import { useTranslator as useGoogleTranslator } from "./Translator";
import { useLanguage } from "../providers/LanguageProvider";

export const TranslatorSelect = ({ items }) => {
  const [lang, setLang] = useState("US");
  const [open, setOpen] = useState(false);

  const { setLanguage } = useTranslator();
  const { setLanguage: setGoogleLanguage } = useLanguage();
  const { setLanguage: setGoogleTranslatorLanguage } =
    useGoogleTranslator();

  const handleLanguageChange = (countryCode) => {
    setLanguage(countryCode);
    setLang(countryCode);
    setOpen(false);

    if (countryCode === "US" || countryCode === "UK") {
      setGoogleLanguage("en");
      setGoogleTranslatorLanguage("en");
      return;
    }

    setGoogleLanguage(countryCode.toLowerCase());
    setGoogleTranslatorLanguage(countryCode.toLowerCase());
  };

  return (
    <div className="fixed right-3 top-4 z-[999] w-[95px] xl:top-8">
      {/* Language Button */}
      <div
        onClick={() => setOpen(!open)}
        className="relative h-[42px] cursor-pointer rounded-[10px] border border-[#c4dc5b] "
      >
        <div className="absolute inset-[2px] flex items-center justify-between rounded-[8px] bg-[#0b0b0b] px-3">
          <div className="flex items-center gap-2">
            <img
              src={`./flags/${lang.toLowerCase()}.svg`}
              alt={lang}
              className="h-5 w-5 rounded-full object-cover"
            />

            <span
              className="text-sm font-bold"
              style={{
                background:
                  "linear-gradient(180deg,#efff96 0%,#c4dc5b 45%,#8ea81c 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {lang}
            </span>
          </div>

          <img
            src="./narrow.svg"
            alt="arrow"
            className={`h-3 w-3 transition-transform duration-300 ${
              open ? "rotate-180" : ""
            }`}
          />
        </div>
      </div>

      {/* Dropdown */}
      {open && (
        <div className="mt-2 overflow-hidden rounded-[10px] border border-[#c4dc5b]/40 bg-[#0b0b0b] shadow-[0_0_18px_rgba(196,220,91,0.2)]">
          {items.map((item, index) => (
            <div
              key={index}
              onClick={() => handleLanguageChange(item)}
              className="flex cursor-pointer items-center gap-3 border-b border-[#c4dc5b]/10 px-3 py-3 transition-all duration-200 last:border-b-0 hover:bg-[#c4dc5b]/10"
            >
              <img
                src={`./flags/${item.toLowerCase()}.svg`}
                alt={item}
                className="h-5 w-5 rounded-full object-cover"
              />

              <span className="text-sm font-medium text-white hover:text-[#c4dc5b]">
                {item}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};